const common = {
  nav: {
    home: 'Início',
    orderOnline: 'Pedir Online',
    deliverySchedule: 'Agendar Entrega',
    contact: 'Contato'
  },
  hero: {
    badge: 'Culinária Brasileira Autêntica',
    title1: 'Sabor do',
    title2: 'Brasil',
    title3: 'Entregue Fresco',
    description: 'Experimente o calor e o sabor da autêntica culinária caseira brasileira. Dita traz receitas tradicionais passadas por gerações, feitas com amor e os melhores ingredientes, direto para sua porta.',
    orderBtn: 'Pedir Online',
    menuBtn: 'Ver Cardápio',
    step1Title: '1. Escolha',
    step1Desc: 'Selecione seus pratos brasileiros favoritos',
    step2Title: '2. Peça',
    step2Desc: 'Faça seu pedido e agende a entrega',
    step3Title: '3. Receba',
    step3Desc: 'Aproveite comida fresca entregue na sua porta'
  },
  instagram: {
    badge: 'Siga-nos',
    title1: 'Fresquinho da',
    title2: 'Nossa Cozinha',
    subtitle: 'Veja o que estamos preparando! Siga-nos no Instagram para promoções diárias, novos pratos e bastidores.'
  },
  menu: {
    subtitle: 'Nossas Especialidades',
    title1: 'Sabores',
    title2: 'Brasileiros',
    title3: 'Tradicionais',
    mainDishes: 'Pratos Principais',
    desserts: 'Sobremesas',
    combos: 'Combos'
  },
  orderOnline: {
    title: 'Peça',
    titleAccent: 'Agora',
    subtitle: 'Selecione seus favoritos e agende a entrega',
    cashOnly: 'Pagamento Apenas em Dinheiro ou Interact',
    addToCart: 'Adicionar ao Carrinho',
    all: 'Todos',
    scheduleText1: 'Agende sua entrega',
    scheduleText2: 'com facilidade e aproveite',
    scheduleText3: 'sabores brasileiros autênticos',
    scheduleBtn: 'Agendar Entrega'
  },
  deliverySchedule: {
    title: 'Agendar',
    titleAccent: 'Entrega',
    subtitle: 'Escolha sua data e horário preferidos para entrega. Confirmaremos seu pedido por e-mail.',
    calendlyNote: 'Selecione sua data e horário preferidos para entrega. Confirmaremos seu pedido por e-mail.'
  },
  contact: {
    title: 'Entre em Contato',
    subtitle: 'Adoraríamos ouvir você',
    name: 'Nome',
    email: 'E-mail',
    phone: 'Telefone',
    message: 'Mensagem',
    submit: 'Enviar Mensagem',
    sending: 'Enviando...',
    success: 'Mensagem enviada com sucesso!',
    error: 'Falha ao enviar mensagem. Tente novamente.',
    info: {
      title: 'Informações de Contato',
      phone: 'Telefone',
      email: 'E-mail',
      hours: 'Horário de Funcionamento',
      hoursValue: 'Ter-Dom: 11:00 - 20:00'
    }
  },
  footer: {
    language: 'IDIOMA',
    quickLinks: 'LINKS RÁPIDOS',
    followUs: 'SIGA-NOS',
    order: 'Pedir',
    delivery: 'Entrega',
    contact: 'Contato',
    copyright: '© 2025 Dita\'s Brazilian Food | Bilíngue: English & Português',
    poweredBy: 'Website Builder'
  },
  cart: {
    title: 'Seu Pedido',
    empty: 'Seu carrinho está vazio',
    total: 'Total',
    checkout: 'Finalizar Pedido',
    remove: 'Remover',
    quantity: 'Quantidade',
    added: 'Adicionado!'
  },
  orderForm: {
    title: 'Complete Seu Pedido',
    customerInfo: 'Informações do Cliente',
    deliveryInfo: 'Informações de Entrega',
    orderSummary: 'Resumo do Pedido',
    name: 'Nome Completo',
    email: 'E-mail',
    phone: 'Número de Telefone',
    address: 'Endereço de Entrega',
    city: 'Cidade',
    postalCode: 'Código Postal',
    deliveryDate: 'Data de Entrega Preferida',
    deliveryTime: 'Horário de Entrega Preferido',
    specialInstructions: 'Instruções Especiais',
    paymentMethod: 'Método de Pagamento',
    cashOnDelivery: 'Pagamento na Entrega',
    submit: 'Fazer Pedido',
    submitting: 'Fazendo Pedido...',
    success: 'Pedido realizado com sucesso! Verifique seu e-mail para confirmação.',
    error: 'Falha ao fazer pedido. Tente novamente.'
  }
};

export default common;